// Vue 3 click-outside directive (replaces the Vue 2 bind/unbind variants)
export const clickOutside = {
	mounted(el, binding) {
		el.__clickOutsideHandler__ = (event) => {
			if (!(el === event.target || el.contains(event.target))) {
				if (typeof binding.value === 'function') {
					binding.value(event)
				}
			}
		}
		document.body.addEventListener('click', el.__clickOutsideHandler__)
	},
	unmounted(el) {
		document.body.removeEventListener('click', el.__clickOutsideHandler__)
		delete el.__clickOutsideHandler__
	},
}

export default clickOutside
